import { StatTableTd } from "components/StatsTable/styles";
import styled from "styled-components";
import { FlexRow } from "styles/layout";

export const ImageCell = styled(StatTableTd)`
  padding: 4px;
`;

export const ImageCellContents = styled(FlexRow)`
  overflow: hidden;
  width: 135px;
  height: 60px;
  margin: auto;

  @media (max-width: 1000px) {
    width: 110px;
    height: 55px;
    font-size: 9.5pt;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const ImageText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  font-weight: bold;
  font-size: 13pt;
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;

  @media (max-width: 1000px) {
    font-size: 11.5pt;
  }
`;

export const Image = styled.img<{ hasText: boolean }>`
  max-width: 100%;
  max-height: 100%;

  ${({ hasText }) => hasText && `filter: brightness(0.8);`}
`;
